module.exports = __webpack_public_path__ + "static/media/M-Cure T7.b69b3e6c.jpg";